import React from 'react'
import { ButtonGroup } from '@pandiafi/design-system'

import { BulletinType } from '../../../../../common/validations'

interface BulletinLanguageSelectorProps {
  language: BulletinType['language']
  availableLanguages: BulletinType['availableLanguages']
  onLanguageChange: (language: BulletinType['language']) => void
}

const languageLabels: Record<BulletinType['language'], string> = {
  fi: 'FI',
  sv: 'SV',
  en: 'EN',
}

export const BulletinLanguageSelector: React.FC<
  BulletinLanguageSelectorProps
> = ({ language, availableLanguages, onLanguageChange }) => {
  if (availableLanguages.length <= 1) {
    return null
  }

  const suggestions = availableLanguages.map((lang) => ({
    id: lang,
    label: languageLabels[lang],
  }))

  return (
    <ButtonGroup
      variant="text"
      className="space-x-2 text-sm"
      value={language}
      onChange={(value) => {
        const nextLanguage = availableLanguages.find(
          (availableLanguage) => availableLanguage === value
        )
        if (nextLanguage) onLanguageChange(nextLanguage)
      }}
      suggestions={suggestions}
    />
  )
}
